import axios, {
  AUTH_MULTI_ACCOUNT_PREFIX,
  MULTI_ACCOUNT_PREFIX,
} from 'src/clients/axios';
import {
  ChildTopUpParams,
  ChildTopUpResponse,
  ChildUsernameStatusParams,
  ChildUsernameStatusResponse,
  GetChildStatementResponse,
  GetChildTypeResponse,
  GetChildrenListParams,
  GetChildrenListResponse,
  GetChildrenStatementParams,
  MULTI_ACCOUNT_MANAGEMENT_CHILDREN_LIST_URL,
  MULTI_ACCOUNT_MANAGEMENT_CHILDREN_STATEMENT_URL,
} from 'src/models';

export const checkChildUsernameStatus = (data: ChildUsernameStatusParams) => {
  return axios.request<ChildUsernameStatusResponse>({
    method: 'post',
    url: `${AUTH_MULTI_ACCOUNT_PREFIX}/child/validate`,
    data,
  });
};

export const getChildrenList = (params: GetChildrenListParams) => {
  return axios.request<GetChildrenListResponse>({
    method: 'get',
    url: MULTI_ACCOUNT_MANAGEMENT_CHILDREN_LIST_URL,
    params,
  });
};

export const getExportedChildrenList = (params: GetChildrenListParams) => {
  return axios.request<GetChildrenListResponse>({
    method: 'get',
    url: `${MULTI_ACCOUNT_PREFIX}/child/download`,
    params,
  });
};

export const getChildType = (productionData = false) => {
  return axios.request<GetChildTypeResponse>({
    method: 'get',
    url: `${AUTH_MULTI_ACCOUNT_PREFIX}/child-type`,
    onlyProduction: productionData,
  });
};

export const getChildrenStatement = (params: GetChildrenStatementParams) => {
  return axios.request<GetChildStatementResponse>({
    method: 'get',
    url: MULTI_ACCOUNT_MANAGEMENT_CHILDREN_STATEMENT_URL,
    params,
  });
};

export const downloadChildrenStatement = (
  params: GetChildrenStatementParams,
) => {
  return axios.request<GetChildStatementResponse>({
    method: 'get',
    url: `${MULTI_ACCOUNT_PREFIX}/child/account-statement/download`,
    params,
  });
};

export const postTopUpChild = (data: ChildTopUpParams) => {
  return axios.request<ChildTopUpResponse>({
    method: 'post',
    url: `${MULTI_ACCOUNT_PREFIX}/child/top-up`,
    data,
  });
};
